'use client'

import { useState } from 'react'
import { Alert } from '@shc/ui'
import type { TypeIcon } from '@lib/generated-types'
import { getIconFromContentful } from '@lib/icons'
import type { Document } from '@contentful/rich-text-types'
import { richTextRender } from '@lib/rich-text-base'
import clsx from 'clsx'

interface AlertBarProps {
  description: Document
  icon?: TypeIcon
  className?: string
}

const AlertBar = ({
  description,
  icon,
  className,
}: AlertBarProps) => {
  const [isOpen, setIsOpen] = useState(true)

  return (
    isOpen && (
      <Alert
        className={clsx('mt-3', className ?? '')}
        icon={getIconFromContentful(icon)}
        onClose={() => setIsOpen(false)}>
          {richTextRender(description)}
      </Alert>
    )
  )
}

export default AlertBar
